import React from 'react'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import { UserMinus, UsersThree } from '@phosphor-icons/react'
import RbacUserSearchField from '../shared/RbacUserSearchField'
import {
  RBAC_ADD_USERS_FILTER_ALL,
  RBAC_ADD_USERS_FILTER_UNASSIGNED,
  RBAC_ADD_USERS_SEARCH_PLACEHOLDER,
  rbacAddUsersFilterGroupSx,
  rbacAddUsersSearchFieldSx
} from '../constants/rbacAddUsersToRoleDialogConstants'

export default function RbacAddUsersToolbar({
  filter,
  onFilterChange,
  searchInput,
  onSearchChange
}) {
  return (
    <>
      <ToggleButtonGroup
        color="primary"
        value={filter}
        exclusive
        onChange={onFilterChange}
        aria-label="Filtro de usuarios"
        sx={rbacAddUsersFilterGroupSx}
      >
        <ToggleButton value={RBAC_ADD_USERS_FILTER_ALL} aria-label="Todos">
          <UsersThree size={16} weight="regular" aria-hidden />
          Todos
        </ToggleButton>
        <ToggleButton value={RBAC_ADD_USERS_FILTER_UNASSIGNED} aria-label="Sin rol">
          <UserMinus size={16} weight="regular" aria-hidden />
          Sin rol
        </ToggleButton>
      </ToggleButtonGroup>

      <RbacUserSearchField
        value={searchInput}
        onChange={onSearchChange}
        placeholder={RBAC_ADD_USERS_SEARCH_PLACEHOLDER}
        sx={rbacAddUsersSearchFieldSx}
      />
    </>
  )
}
